'use strict';

const eventBinding = require('./event.binding');
const flowCache = require('./flow.cache');
const pageRegister = require('./page.register');
const trackingSend = require('./tracking.send');

const eventHandler = ({flow, label}) => {
    flowCache.enqueue({flow, label});
    trackingSend.sendEventTrack(flow);
};

const clearCacheIfRequested = ({clearCache = false}) => clearCache && flowCache.clear();

module.exports = {
    registerPage(info) {
        clearCacheIfRequested(info);
        eventBinding.bindEvents(info, trackingSend.sendAppearancesTrackingAtPageLoad);
        pageRegister.load(eventHandler);
        eventBinding.bindAppearancesTrackingAtPageLoad(info, trackingSend.sendAppearancesTrackingAtPageLoad);
    },

    registerWidget(policy) {
        pageRegister.load(eventHandler, policy);
    },

    launchEvent({flow, label}) {
        eventHandler({flow, label});
    },

    launchAppearancesTracking(widget) {
        trackingSend.sendAppearancesTracking(trackingSend.getTrackingPageFlowAppearancesInfo(widget));
    },
};
